'use client';

import { type CSSProperties, useState } from 'react';
import EmailIcon from '@pixum/svg-icon/lib/Standard/Email';
import PhoneIcon from '@pixum/svg-icon/lib/Standard/Phone';
import RightArrow from '@pixum/svg-icon/lib/Arrows/ForwardIos';
import Text, { TEXT_VARIANT, TextTag } from '@pixum/text';
import type { ContactLinkListProps } from './types';
import { Label, LabelWithLinkMasking } from '../../../label';
import { EMPTY_PLACEHOLDER } from '../../../../constants';
import { removeEmptySpaces } from 'utils';
import clsx from 'clsx';

export function ContactLinkList(props: ContactLinkListProps) {
  const { align, direction, flow, contact, type, expanded = false } = props;
  const [checked, setChecked] = useState(expanded);
  const { weekdayOpening, email, weekendOpening, constants, phone } = contact;
  const showWeekdayOpening = weekdayOpening && weekdayOpening !== EMPTY_PLACEHOLDER;
  const showWeekendOpening = weekendOpening && weekendOpening !== EMPTY_PLACEHOLDER;
  const customProperties = {
    '--footer-links-list-item-align': align,
    '--footer-links-list-item-direction': direction,
    '--footer-links-list-item-flow': flow
  } as CSSProperties;
  const showEmailReactionTimeHint = constants.i18n_email_reaction_time !== '';

  return (
    <section className="footer__links-list-section variant-text collapsible" id={type}>
      <Text className="footer__links-list-heading" variant={TEXT_VARIANT.HEADLINE}>
        {constants.i18n_contact}
      </Text>
      <input id={`footer-links-list-collapsible-${type}`} type="checkbox" onChange={() => setChecked(!checked)} />
      <label
        className={clsx('footer__links-list-label', checked && 'expanded')}
        htmlFor={`footer-links-list-collapsible-${type}`}
      >
        <Text variant={TEXT_VARIANT.BODY} tag={TextTag.SPAN}>
          {constants.i18n_contact}
        </Text>
        <RightArrow />
      </label>
      <ul className={clsx('footer__links-list', checked && 'expanded')} style={customProperties}>
        <li className="footer__links-list-item">
          <Label text={constants.i18n_customer_service_is_there} variant={TEXT_VARIANT.CAPTION} />
        </li>
        {showWeekdayOpening && (
          <li className="footer__links-list-item">
            <Label text={weekdayOpening} />
          </li>
        )}
        {showWeekendOpening && (
          <li className="footer__links-list-item">
            <Label text={weekendOpening} />
          </li>
        )}
        {phone && (
          <li className="footer__links-list-item">
            <LabelWithLinkMasking
              href={`tel:${removeEmptySpaces(phone)}`}
              icon={<PhoneIcon color="white" />}
              text={phone}
              title={phone}
              variant={TEXT_VARIANT.CAPTION}
            />
          </li>
        )}
        {email && (
          <li className="footer__links-list-item">
            <LabelWithLinkMasking
              href={`mailto:${email}`}
              icon={<EmailIcon color="white" />}
              text={email}
              title={email}
              variant={TEXT_VARIANT.CAPTION}
            />
            {showEmailReactionTimeHint && (
              <Text variant={TEXT_VARIANT.CAPTION}>{constants.i18n_email_reaction_time}</Text>
            )}
          </li>
        )}
      </ul>
    </section>
  );
}
